<template>
  <div class="table-toolbar-container card-box">
    <div class="toolbar-left-group">
      <slot name="left"></slot>
      <slot></slot>
    </div>

    <div class="toolbar-right-group">
      <!-- 模糊关键字搜索 -->
      <el-input
        v-if="showSearch"
        v-model="internalSearch"
        size="small"
        :placeholder="searchPlaceholder"
        clearable
        class="search-input"
        prefix-icon="el-icon-search"
        @input="handleSearchInput"
      >
        <i slot="suffix" class="el-icon-set-up" style="line-height: 32px; color: #94a3b8; font-size: 14px; margin-right: 4px;"></i>
      </el-input>

      <!-- 刷新按钮 -->
      <el-tooltip v-if="showRefresh" content="刷新数据" placement="top" :enterable="false" :open-delay="500">
        <el-button size="small" icon="el-icon-refresh" class="btn-icon-action" @click="$emit('refresh')"></el-button>
      </el-tooltip>

      <!-- 导出按钮（支持业务页面覆盖导出菜单） -->
      <slot name="export">
        <template v-if="showExport">
          <el-popconfirm
            :title="exportConfirmTitle"
            confirm-button-text="确定"
            cancel-button-text="取消"
            icon="el-icon-info"
            icon-color="#3b82f6"
            @confirm="$emit('export')"
            style="display: inline-block;"
          >
            <el-tooltip slot="reference" content="导出数据" placement="top" :enterable="false" :open-delay="500">
              <el-button size="small" :loading="exportLoading" icon="el-icon-download" class="btn-icon-action"></el-button>
            </el-tooltip>
          </el-popconfirm>
        </template>
      </slot>

      <!-- 列配置按钮 -->
      <column-settings
        v-if="showColumnSettings"
        :columns="columns"
        :value="visibleColumns"
        :default-columns="defaultColumns"
        :fixed-columns="fixedColumns"
        :min-selected="minSelected"
        @input="handleColumnChange"
      />
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
import ColumnSettings from '../ColumnSettings/index.vue'

export default {
  name: 'TableToolbar',
  components: { ColumnSettings },
  props: {
    search: {
      type: String,
      default: ''
    },
    searchPlaceholder: {
      type: String,
      default: '输入关键字模糊搜索...'
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    showRefresh: {
      type: Boolean,
      default: true
    },
    showExport: {
      type: Boolean,
      default: false
    },
    exportLoading: {
      type: Boolean,
      default: false
    },
    exportConfirmTitle: {
      type: String,
      default: '确定要导出当前过滤后的配置数据吗？'
    },
    showColumnSettings: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: () => []
    },
    visibleColumns: {
      type: Array,
      default: () => []
    },
    defaultColumns: {
      type: Array,
      default: () => []
    },
    fixedColumns: {
      type: Array,
      default: () => []
    },
    minSelected: {
      type: Number,
      default: 4
    }
  },
  data () {
    return {
      internalSearch: this.search
    }
  },
  watch: {
    search (newVal) {
      this.internalSearch = newVal
    }
  },
  methods: {
    handleSearchInput (val) {
      this.$emit('update:search', val)
      this.$emit('search-change', val)
    },
    handleColumnChange (val) {
      this.$emit('update:visibleColumns', val)
      this.$emit('column-change', val)
    }
  }
}
</script>

<style scoped>
.table-toolbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 0 !important;
  margin-bottom: 20px;
  padding: 16px 24px;
  border-radius: 8px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-base);
}
.toolbar-left-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.toolbar-right-group {
  display: flex;
  align-items: center;
  gap: 12px;
}
.search-input {
  width: 220px;
  flex-shrink: 0;
  height: 32px !important;
}
.search-input :deep(.el-input__inner) {
  border-radius: 8px;
  border-color: var(--border-color);
  height: 32px;
  line-height: 32px;
  font-weight: 500;
  background-color: var(--bg-card);
  color: var(--text-main);
  transition: all 0.2s ease;
}
.search-input :deep(.el-input__inner:hover) {
  border-color: var(--border-hover);
}
.search-input :deep(.el-input__inner:focus) {
  border-color: var(--primary-color, #2563eb);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}
.btn-icon-action {
  background-color: var(--bg-card) !important;
  border-color: var(--border-color) !important;
  color: var(--text-muted) !important;
  border-radius: 8px !important;
  height: 32px !important;
  width: 32px !important;
  padding: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0 !important;
  box-sizing: border-box !important;
}
.btn-icon-action:hover {
  background-color: var(--bg-page) !important;
  border-color: var(--border-hover) !important;
  color: var(--text-main) !important;
}
</style>
